import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const ordersSlice = createSlice({
    name: 'ui/orders',
    initialState: { ...initialState, populates: ['company', 'subscription', 'user'] },
    reducers: listReducers
})

export const ordersActions = ordersSlice.actions
export default ordersSlice.reducer
